module.exports = __webpack_public_path__ + "static/img/img-perso-ok.e4bad68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/img-perso-ok.png
// module id = U74D
// module chunks = 0